<template>
    <div id="useCase">
        <div id="twoBox" class="drag-two-box">
            <div id="twoleft" class="drag-two-left">
                <div id="threeBox">
                    <div id="routes">
                        <routes ref="routesRef" :key="keyCom" :routesHeight="routesHeight" v-on:emitheaderUid="getHeaderUid" @routeNo="getRouteNo" ></routes>
                    </div>
                    <div id="threeResizeOne" class="r-resize" ></div>
                    <div id="wayPoints">
                        <way-points ref="wayPointsRef" :key="keyCom" :wapPointsHeight="wapPointsHeight" :routesHeaderUId="routes.routesHeaderUid" @googleMapLineList="getGoogleMapLineList" v-on:emitWayUid="getWayUid" @waypointNo="getWaypointNo" v-on:emitDeliveriesUid="getDeliveriesUid"></way-points>
                    </div>
                    <div id="threeResizeTwo" class="r-resize"></div>
                    <div id="deliveries">
                        <deliveries v-on:emitDelvs="getemitDelvsr" :key="keyCom" ref="delComsRef" :deliveriesHeight="deliveriesHeight" :wayUid="way.wayUid" v-on:emitDeliveriesUid="getDeliveriesUid"></deliveries>
                    </div>
                </div>
            </div>
            <div id="tworesize" class="drag-two-resize"></div>
            <div id="tworight" class="drag-two-right" >
                <div id="mainId" class="main">
                    <div id="topBoxId" class="topBox" hidden="true">
                        <a-row style="border: 1px solid gray;overflow: hidden;">
                            <div v-if="false" class="app-container">
                                <a-input id="suggestId" size="large" style="width: 100%;"/>
                                <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
                                <div style="margin: 5px">
                                    <baidu-map class="bm-view" :style="{ height: mapRightHeight }" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom="true" ak="baidu-ak" @ready="handlerBMap" />
                                </div>
                            </div>
                            <div v-else-if="true"  class="app-container">
                                <div style="margin: 5px">
                                    <template>
                                        <div>
                                            <div>
                                                <label style="width: 100%">
                                                    <gmap-autocomplete
                                                            @place_changed="setPlace" :options="{fields: ['geometry', 'formatted_address', 'address_components']}" style="width: 100%">
                                                    </gmap-autocomplete>
                                                    <!--<button @click="addMarker">Search</button>-->
                                                </label>
                                                <br/>

                                            </div>
                                            <gmap-map
                                                    :center="center"
                                                    :zoom="13"
                                                    style="width:100%;"
                                                    :style="{ height: mapRightHeight }"
                                            >
                                                <gmap-marker
                                                        :key="index"
                                                        v-for="(m, index) in markers"
                                                        :position="m.position"
                                                        @click="center=m.position"
                                                ></gmap-marker>

                                                <p v-for="(polylineArray,i) in gmapPolylineList">
                                                    <gmap-polyline
                                                            :path="polylineArray"
                                                            v-bind:options="lineColors[i]"
                                                    >
                                                    </gmap-polyline>

                                                    <gmap-marker
                                                            :key="index"
                                                            v-for="(m, index) in polylineArray"
                                                            :position="m"
                                                    ></gmap-marker>
                                                </p>

                                              <!--  <gmap-polyline
                                                        :path="this.polylineArray"
                                                         v-bind:options="lineColors[i]"
                                                >
                                                </gmap-polyline>

                                                <gmap-marker
                                                        :key="index"
                                                        v-for="(m, index) in polylineArray"
                                                        :position="m"
                                                ></gmap-marker>-->


                                             </gmap-map>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </a-row>
                    </div>
                    <div id="resizeId" class="r-resize"></div>
                    <div id="downBoxId" class="downBox">
                        <orders :key="keyCom" :ordersHeight="ordersHeight" ref="orderRef" :routeNo=routes.routeNo :tmsUids="tmsUids" :waypointNo="way.waypointNo" :wayUid="way.wayUid" v-on:emitDeliveriesUid="getDeliveriesUid"></orders>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ajax from "../../api/ajax";
    import api from "../../api/url";
   // import GoogleMap from "./GoogleMap";
    import {mapState} from "vuex";
    import Vue from 'vue'
    import BaiduMap from 'vue-baidu-map';
    import * as VueGoogleMaps from 'vue2-google-maps';
    Vue.use(VueGoogleMaps, {
        load: {
            key:'AIzaSyAIYzrwapJF0wPNsHNb2s7dQK0uq6zFrtc',
            libraries: 'places'
        }
    })
    Vue.use(BaiduMap, {
        // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
        ak: 'Rk5haXyGao5bGyedhSHUGf1grzGAQccP'
    })

    import routes from './tmsComs/routes.vue'
    import wayPoints from './tmsComs/wayPoints.vue'
    import deliveries from './tmsComs/deliveries.vue'
    import orders from './tmsComs/orders.vue'
    export default{
        components:{
            routes,
            wayPoints,
            deliveries,
            orders
        },
        computed: {},
        data(){
            return{
                keyCom:0,
//                地图
                mapRightHeight: '',
                mapZoom: 15,
                mapCenter: { lng: 0, lat: 0 },
                mapLocation: {
                    address: undefined,
                    coordinate: undefined
                },
                center: { lat: 22.285, lng: 114.211 },
                markers: [],
                zoom:18,
                places: [],
                gmapPolylineList:[],
                lineColors: [],
               // polylineArray:[],
                currentPlace: null,

//                组件高度
                routesHeight: null,
                wapPointsHeight: null,
                deliveriesHeight: null,
                ordersHeight: null,
                tmsUids: {},

                routes:{
                    routesHeaderUid: null, // routes 单机返回的当前uid
                    routeNo:null // routes 单机返回的当前routeNo
                },
                way:{
                    wayUid: null,// waypoint 单击返回的当前wayUid
                    waypointNo :null // waypoint 单击返回的当前wayNo

                },
            }
        },
        created(){
//          初始化地图高度
            this.$nextTick(()=>{
                let mainId = document.getElementById('mainId');
                let downBoxId = document.getElementById('downBoxId');
                this.mapRightHeight =mainId.offsetHeight - downBoxId.offsetHeight - 50 + 'px'
                //                初始化orders 高度
                this.ordersHeight = downBoxId.offsetHeight - 70
                //            初始化routes 高度
                let routesId = document.getElementById('routes');
                this.routesHeight = routesId.offsetHeight - 75
                //            初始化wapPoints 高度
                let wayPointsId = document.getElementById('wayPoints');
                this.wapPointsHeight = wayPointsId.offsetHeight - 70
//                初始化deliveries 高度
                let deliveries = document.getElementById('deliveries');
                this.deliveriesHeight = deliveries.offsetHeight - 70
            })
        },
        mounted() {
            this.geolocate();
            this.dragTwoColDiv("twoBox", "twoleft", "tworesize", "tworight")
            this.dragTwoRowDiv("mainId", "topBoxId", "resizeId", "downBoxId");
            this.dragThreeColDiv("threeBox","routes","threeResizeOne","wayPoints","threeResizeTwo","deliveries");
        },
        methods:{
            cleardata(){
                this.keyCom ++
            },
//            routes 返回的uid
            getHeaderUid(val){
                this.routes.routesHeaderUid = val
            },
//            wayPoints 返回当前的uid
            getWayUid(val){
                this.way.wayUid = val
            },
//            Deliverie 双击返回的返回当前的uid
            getDeliveriesUid(val){
                if(val == 'Orderinit'){
                    this.$refs.orderRef.init()
                    this.$refs.routesRef.init()
                    this.$refs.wayPointsRef.init()
                }
                else{
                    this.$refs.orderRef.delEdit(val)
                }

            },
            getRouteNo(val){
                this.routes.routeNo = val
            },
            getWaypointNo(val){
                this.way.waypointNo = val
            },
//            order 拖拽del 成功刷新del
            getemitDelvsr(type){
                if(type == 'init'){
                    this.$refs.orderRef.init()
                }
                if(type =='order'){
                    this.ordersInit()
                }
            },
//            routes 请求刷新orders
            ordersInit(){
                this.$refs.orderRef.init()
            },
            routesupdata(){
                this.$refs.routesRef.init()
            },
            getrRourtesRef(){
              return this.$refs.routesRef.getTableCkeck()
            },
            getGoogleMapLineList(v){
                this.gmapPolylineList = [];
                this.lineColors = [];

                console.log(v)
                this.gmapPolylineList.push(v.gmapPolylineList);
                this.lineColors = v.gmapColorLineList;
            },

            //Baidu地图
            handlerBMap({BMap, map}) {
                //console.log(BMap, map)
                // 鼠标缩放
                //map.enableScrollWheelZoom(true);
                // 点击事件获取经纬度
                /* map.addEventListener('click', function (e) {
                     console.log(e.point.lng, e.point.lat)
                 });*/
                /*   var local = new BMap.LocalSearch(map, {
                       renderOptions:{map: map}
                   });
                   local.search("香港");*/

                this.BMap = BMap
                this.map = map
                //地图初始化

                map.addControl(new BMap.NavigationControl());

                if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
                    this.mapCenter.lng = this.mapLocation.coordinate.lng
                    this.mapCenter.lat = this.mapLocation.coordinate.lat
                    this.mapZoom = 15
                    map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate))
                } else {
                    this.mapCenter.lng = 114.211
                    this.mapCenter.lat = 22.285
                    this.mapZoom = 13
                }
                map.addEventListener('click', function (e) {
                    console.log(e.point.lng, e.point.lat)
                })


                var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
                    {"input" : "suggestId"
                        ,"location" : map
                    });
                ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
                    var str = "";
                    var _value = e.fromitem.value;
                    var value = "";
                    if (e.fromitem.index > -1) {
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

                    value = "";
                    if (e.toitem.index > -1) {
                        _value = e.toitem.value;
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                    document.getElementById("searchResultPanel").innerHTML = str;
                });

                var myValue;
                ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
                    var _value = e.item.value;
                    myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    document.getElementById("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;

                    setPlace();
                });

                function setPlace(){
                    map.clearOverlays();    //清除地图上所有覆盖物
                    function myFun(){
                        var pp = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
                        map.centerAndZoom(pp, 18);
                        map.addOverlay(new BMap.Marker(pp));    //添加标注
                    }
                    var local = new BMap.LocalSearch(map, { //智能搜索
                        onSearchComplete: myFun
                    });
                    local.search(myValue);
                }
            },

            //Google Map
            setPlace(place) {
                this.currentPlace = place;
                this.addMarker();
            },
            addMarker() {
                if (this.currentPlace) {
                    const marker = {
                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng()
                    };
                    this.markers.push({ position: marker });

                    const flightPlanCoordinates = [
                        { lat: 22.302, lng: 114.180 },
                        { lat: 22.306, lng: 114.168 },
                        { lat: 22.235, lng: 114.162 },
                        { lat: 22.332, lng: 114.180 },
                    ];
                    this.markers.push(flightPlanCoordinates);

                    this.places.push(this.currentPlace);
                    this.center = marker;
                    this.zoom=20;
                    this.currentPlace = null;
                }
            },
            geolocate() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });

/*
                const polylineArray1 = [
                    { lat: 22.302, lng: 114.180 },
                    { lat: 22.306, lng: 114.168 },
                    { lat: 22.301, lng: 114.162 },
                    { lat: 22.332, lng: 114.180 },
                ];
                const polylineArray2 = [
                    { lat: 22.330, lng: 114.158 },
                    { lat: 22.317, lng: 114.162 },
                    { lat: 22.316, lng: 114.185 },
                ];
                const polylineArray3 = [
                    { lat: 22.320, lng: 114.176 },
                    { lat: 22.328, lng: 114.188 },
                    { lat: 22.335, lng: 114.194 },
                ];
                this.gmapPolylineList.push(polylineArray1);
                this.gmapPolylineList.push(polylineArray2);
                this.gmapPolylineList.push(polylineArray3);

                const polylineColor1 = {strokeColor:'#008000'};
                const polylineColor2 = {strokeColor:'#000000'};
                const polylineColor3 = {strokeColor:'#330099'};

                this.lineColors.push(polylineColor1);
                this.lineColors.push(polylineColor2);
                this.lineColors.push(polylineColor3);*/


            },
            //            推拽
            dragTwoColDiv(contentId,leftBoxId,resizeId,rightBoxId){
                let resize = document.getElementById(resizeId);
                let leftBox = document.getElementById(leftBoxId);
                let rightBox = document.getElementById(rightBoxId);
                let box = document.getElementById(contentId);
                resize.onmousedown = function (e) {
                    let startX = e.clientX;
                    resize.left = resize.offsetLeft;
                    document.onmousemove = function (e) {
                        let endX = e.clientX;
                        let moveLen = resize.left + (endX - startX);
                        let maxT = box.clientWidth - resize.offsetWidth;
                        if (moveLen < 150) moveLen = 150;
                        if (moveLen > maxT - 150) moveLen = maxT - 150;
                        resize.style.left = moveLen;
                        leftBox.style.width = moveLen + 'px';
                        rightBox.style.width = (box.clientWidth - moveLen - 5) + 'px';
                    }
                    document.onmouseup = function () {
                        document.onmousemove = null;
                        document.onmouseup = null;
                        resize.releaseCapture && resize.releaseCapture();
                    }
                    resize.setCapture && resize.setCapture();
                    return false;
                }
            },
            dragTwoRowDiv(contentId,topBoxId,resizeId,downBoxId){
                let that = this
                let resize = document.getElementById(resizeId);
                let topBox = document.getElementById(topBoxId);
                let downBox = document.getElementById(downBoxId);
                let box = document.getElementById(contentId);
                resize.onmousedown = function (e) {
                    let startY = e.clientY;
                    resize.top = resize.offsetTop;
                    document.onmousemove = function (e) {
                        let endY = e.clientY;
                        let moveLen = resize.top + (endY - startY);
                        let maxT = box.clientHeight - resize.offsetHeight;
                        if (moveLen < 100) moveLen = 100;
                        if (moveLen > maxT - 100) moveLen = maxT - 100;
                        resize.style.top = moveLen;
                        topBox.style.height = moveLen + "px";
                        that.mapRightHeight = moveLen - 50 + "px"
                        downBox.style.height = (box.clientHeight - moveLen - 5) + "px";
                        that.ordersHeight = (box.clientHeight - moveLen - 5) - 70
                    }
                    document.onmouseup = function () {
                        document.onmousemove = null;
                        document.onmouseup = null;
                        resize.releaseCapture && resize.releaseCapture();
                    }
                    resize.setCapture && resize.setCapture();
                    return false;
                }
            },
            dragThreeColDiv(contentId,topBoxId,resizeOne,centerBoxId,resizeTwo,bottomBoxId) {
                let resizeO = document.getElementById(resizeOne);
                let resizeT = document.getElementById(resizeTwo);
                let topBox = document.getElementById(topBoxId);
                let bottomBox = document.getElementById(bottomBoxId);
                let centerBox = document.getElementById(centerBoxId);
                let box = document.getElementById(contentId);
                let that =this
                resizeO.onmousedown = function (e) {
                    let startY = e.clientY;
                    resizeO.top = resizeO.offsetTop;
                    document.onmousemove = function (e) {
                        let endY = e.clientY;
                        let rightW = bottomBox.offsetHeight;
                        let moveLen = resizeO.top + (endY - startY);
                        let maxT = box.clientHeight - resizeO.offsetHeight;
                        if (moveLen < 150) moveLen = 150;
                        if (moveLen > maxT - rightW - 150) moveLen = maxT - rightW - 150;
                        resizeO.style.top = moveLen;
                        topBox.style.height = moveLen + 'px';
                        that.routesHeight = moveLen - 75
                        centerBox.style.height = (box.clientHeight - moveLen - rightW - 10) + 'px';
                        that.wapPointsHeight = (box.clientHeight - moveLen - rightW - 10) - 70
                    }
                    document.onmouseup = function () {
                        document.onmousemove = null;
                        document.onmouseup = null;
                        resizeO.releaseCapture && resizeO.releaseCapture();
                    }
                    resizeO.setCapture && resizeO.setCapture();
                    return false;
                }
                resizeT.onmousedown = function (e) {
                    let startY = e.clientY;
                    resizeT.top = resizeT.offsetTop;
                    document.onmousemove = function (e) {
                        let endY = e.clientY;
                        let leftW = topBox.offsetHeight;
                        let moveLen = resizeT.top + (endY - startY) - leftW;
                        let maxT = box.clientHeight - resizeT.offsetHeight - 5;
                        if (moveLen < 150) moveLen = 150;
                        if (moveLen > maxT - leftW - 150) moveLen = maxT - leftW - 150;
                        resizeT.style.Top = moveLen;
                        centerBox.style.height = moveLen + 'px';
                        that.wapPointsHeight = moveLen - 70
                        bottomBox.style.height = (box.clientHeight - moveLen - leftW - 10) + 'px';
                        that.deliveriesHeight = (box.clientHeight - moveLen - leftW - 10) - 70
                    }
                    document.onmouseup = function () {
                        document.onmousemove = null;
                        document.onmouseup = null;
                        resizeT.releaseCapture && resizeT.releaseCapture();
                    }
                    resizeT.setCapture && resizeT.setCapture();
                    return false;
                }
            },
        }
    }
</script>
<style type="less">
    .routesTitle{
        font-size: 13px;
        margin-bottom:4px;
        margin-top: 4px;
        font-weight: 600;
    }

    #useCase{
        background: #fff;
    }
    /*pub*/
    .r-resize {
        background: #efefef;
    }
    /*三列*/
    #threeBox{
        height:88vh;
    }
    #routes {
        height: calc(30% - 10px);
    }
    #threeResizeOne {
        height: 5px;
        cursor: s-resize;
    }
    #wayPoints {
        height: 40%;
    }
    #threeResizeTwo {
        height: 5px;
        cursor: s-resize;
    }
    #deliveries {
        height: 30%;
    }
       /*两列 */
   #twoBox {
       display: flex;
       height:88vh;
   }
    #twoleft {
        width: calc(65% - 10px);
    }
    #tworesize {
        width: 5px;
        cursor: w-resize;
    }
    #tworight {
        width: 50%;
    }

    /* 两横 */
    #mainId {
        width: 100%;
        height:87vh;
        position: relative;
    }
    #topBoxId {
        height: calc(50% - 5px);
    }
    #resizeId {
        height: 5px;
        cursor: s-resize;
    }
    #downBoxId {
        height: 100%;
    }
    // 辅助修饰
    .all {
        padding: 30px;
        list-style: none;
    }
    .drag-main{
        margin-bottom: 30px;
        h2{
            margin-bottom: 30px;
        }
    }
    .drag-two-box {
        display: flex;
        .drag-two-left {
            background: #1ee3aa;
            height: 100px;
        }
        .drag-two-right {
            background: #eb77eb;
            height:90vh;
        }
        .drag-two-resize {
            width: 5px;
            cursor: w-resize;
            background: #000;
        }
    }

    ul.content {
        display: flex;
        overflow: hidden;
        li {
            height: 100px;
            list-style-type: none;
        }
        .left {
            background: red;
        }
        .center {
            background: #16ffa6;
            padding: 30px;
            box-sizing: border-box;
        }
        .right {
            background: orange;
        }
        .l-resize {
            background: #000;
        }
    }
    .main {
        height: 300px;
        .topBox {
            background: #1ee3aa;
        }
        .downBox {
            background: #eb77eb;
        }
    }
</style>